import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '../helpers/ApiClient';

export const analyticsService = {
    getPaymentTransactions,
    getOrderedProductsHistory,
    getClientAccountsHistory,
    deleteOrderedProduct,
    getClientAccountSummary,
    deleteAccount,
    updateOrderedProduct,
    getDashboardData,
    deleteTransaction,
    deleteAccountBatch,
    updateTransaction,
    sendInvoice,
    getDashboardDataByPartnerSource,
    sendDigitalVatTicket
}

function sendDigitalVatTicket(uuid, email) {
    return apiClient.get(`/client_account/${uuid}/digital-vat-ticket`, {
        params: email ? { email } : {},
        responseType: email ? 'json' : 'blob'
    })
    .then((response) => {
        return response.data
    })
    .catch(async (error) => {
        // error body is a blob when downloading: convert it back to json so handleError can read the message
        if (error.response && error.response.data instanceof Blob) {
            const text = await error.response.data.text();
            try {
                error.response.data = JSON.parse(text);
            } catch (e) {
                error.response.data = { message: text };
            }
        }
        return handleError(error);
    });
}

function sendInvoice(accountId, payload) {
    return apiClient.post(`/client_account/${accountId}/invoice`, payload, {
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function getDashboardDataByPartnerSource() {
    return apiClient.get("/data/dashboard/su", {headers: authHeader()})
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function getDashboardData(timeInterval, startDate = null, endDate = null) {
    const params = {timeInterval: timeInterval};

    if (startDate != null) params.startDate = startDate;
    if (endDate != null) params.endDate = endDate;

    return apiClient.get("/data/dashboard", {
        params: params,
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function getPaymentTransactions(startDateString, endDateString) {

    let startMs = new Date(startDateString).getTime();
    let endMs = new Date(endDateString).getTime();
    
    return apiClient.get("/data/payments", {
        params: {startDate: startMs, endDate: endMs},
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function getOrderedProductsHistory(startDateString, endDateString) {

    let startMs = new Date(startDateString).getTime();
    let endMs = new Date(endDateString).getTime();

    console.log(startMs, endMs);
    
    return apiClient.get("/data/ordered_products", {
        params: {startDate: startMs, endDate: endMs},
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function getClientAccountsHistory(startDateString, endDateString, {userId = null, shiftId = null} = {}) {

    const params = {};

    if (shiftId) {
        params.shiftId = shiftId;
    } else {
        params.startDate = new Date(startDateString).getTime();
        params.endDate = new Date(endDateString).getTime();
    }

    if (userId) {
        params.userId = userId;
    }

    return apiClient.get("/data/accounts", {
        params,
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function getClientAccountSummary(id) {
    return apiClient.get(`/client_account/${id}`, {
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function deleteOrderedProduct(id) {
    return apiClient.delete(`/data/ordered_products/${id}`, {
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function deleteAccount(accountId) {
    return apiClient.delete(`/client_account/${accountId}`, {
        headers: authHeader()}
    )
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function deleteAccountBatch(accountIds) {
    return apiClient.delete(`/client_account`, {
        headers: authHeader(),
        data: accountIds
    })
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function updateOrderedProduct(orderedProduct) {
    return apiClient.patch(`/data/ordered_products/${orderedProduct.orderedProductId}`, orderedProduct, {
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function deleteTransaction(transaction){
    return apiClient.delete(`/client_account/${transaction.clientAccountId}/payment/${transaction.paymentTransactionId}`,{
        headers: authHeader()}
    )
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function updateTransaction(transaction, newType) {
    return apiClient.post(`/client_account/${transaction.clientAccountId}/payment/${transaction.paymentTransactionId}/change_payment_type`, newType, {
        headers: authHeader()
    })
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}